import React, { useMemo } from 'react'
import Style from './keyMetrics.module.css'
import TrendChart from './TrendChart'
import SectionHeader from '../SectionHeader/SectionHeader'
import { useGetSixMonthSummaryQuery } from '../../../../features/connections/connectionsApi'
import { buildKeyMetrics, SERIES } from '../../../../features/connections/keyMetrics'

const KeyMetrics = () => {
    const { data: summary = [], isLoading, isError } = useGetSixMonthSummaryQuery()
    const metrics = useMemo(() => buildKeyMetrics(summary), [summary])

    return (
        <section className={Style.section}>
            <SectionHeader title="Key Metrics" subtitle="Manage and monitor your automation workflows · Last 6 months">
                <ul className={Style.legend}>
                    {SERIES.map((item) => (
                        <li key={item.name}>
                            <span className={Style.legendDot} style={{ background: item.color }} />
                            {item.name}
                        </li>
                    ))}
                </ul>
            </SectionHeader>
            {isError ? (
                <div className={Style.error}>Unable to load key metrics.</div>
            ) : (
                <div className="row">
                    {metrics.map((metric) => (
                        <div key={metric.key} className="col-lg-4 col-md-6 mb-3">
                            <div className={Style.card}>
                                <div className={Style.cardHeader}>
                                    <span className={[Style.icon, metric.tone ? Style[metric.tone] : ''].join(' ')}><i className={metric.icon}></i></span>
                                    <div>
                                        <p className={Style.title}>{metric.title}</p>
                                        <h3 className={Style.value}>{isLoading ? '—' : metric.value}</h3>
                                    </div>
                                </div>
                                {isLoading ? null : <TrendChart labels={metric.labels} series={metric.series} unit={metric.unit} />}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </section>
    )
}

export default KeyMetrics
